import { createElement } from "@max/max";
import { getFullScreenSize } from "../utils/layout";
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { setRemConfig } from '@max/leez-style-util';
import { hotelTheme } from '@max/leez-theme-hotel';
import { setCustomTheme } from '@max/leez-context';
import getQRCode from 'qrcode-generator';
import LImage from '@max/leez-image';
import Text from "@hfe/max-text";
import ModalBaseContainer from "@max/leez-modal-base-container";
import TopView from "@max/leez-top-view";
import View from "@hfe/max-view";
setCustomTheme(hotelTheme);
setRemConfig({
    enabled: true
});
export function useQRCodePopup() {
    const ctx = useMonitorEngineContext();
    const { fullScreenHeight } = getFullScreenSize();
    function createQRCode(url) {
        try {
            const qr = getQRCode(0, 'L');
            qr.addData(url);
            qr.make();
            return qr.createDataURL(12, 0);
        }
        catch (e) {
            ctx._raptorReport.reportLog(`生成二维码失败|${url}`, e, {
                category: 'jsError',
                level: 'error'
            });
            return null;
        }
    }
    function openQRCodePopup(url) {
        const qrCodeImg = createQRCode(url);
        if (!qrCodeImg) {
            return;
        }
        const ConfirmPanel = <TopView>
      <ModalBaseContainer visible={true}>
        <LImage source={{
            uri: 'https://p0.meituan.net/ingee/361ab701a82b8258d72cd576f11fa51514329.png'
        }} style={{
            width: '564rpx',
            height: '771rpx'
        }}>
          
          <View style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '20rpx'
        }}>
            <View style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
              <LImage source={{
            uri: 'https://p0.meituan.net/ingee/e87779e88305911eb5586a27ce8f90a31090.png'
        }} style={{
            width: '33.7rpx',
            height: '36rpx'
        }}/>
              <Text style={{
            color: '#FFFFFF',
            fontFamily: 'PingFang SC',
            fontWeight: 500,
            fontSize: '32rpx',
            lineHeight: '36rpx',
            maxWidth: '224rpx',
            textAlign: 'center',
            marginLeft: '12rpx',
            marginRight: '12rpx'
        }} numberOfLines={1}>扫码分享</Text>
              <LImage source={{
            uri: 'https://p0.meituan.net/ingee/448b717eaa3a36789381b474b533c0011117.png'
        }} style={{
            width: '33.7rpx',
            height: '36rpx'
        }}/>
            </View>
            <Text style={{
            color: '#ffffffa6',
            fontFamily: 'PingFang SC',
            fontWeight: 400,
            fontSize: '20rpx',
            marginTop: '8rpx',
            lineHeight: '28rpx'
        }}>邀请好友扫码助力</Text>

            <LImage source={{
            uri: qrCodeImg
        }} style={{
            width: '400rpx',
            height: '400rpx',
            marginTop: '80rpx'
        }} borderRadius={0}/>

            <View style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '65rpx'
        }}>
              <LImage onPress={closeQRCodePopup} source={{
            uri: 'https://p0.meituan.net/ingee/d88d4404c6061bb633e178818d16080f25010.png'
        }} style={{
            width: '503rpx',
            height: '90rpx'
        }}/>
            </View>
          </View>
        </LImage>
      </ModalBaseContainer>
    </TopView>;
        ctx._topPanelAPI.setPanelHeight(fullScreenHeight);
        ctx._topPanelAPI.setContent(ConfirmPanel);
        ctx._topPanelAPI.setVisible({
            visible: true
        });
    }
    function closeQRCodePopup() {
        ctx._topPanelAPI.setContent(null);
        ctx._topPanelAPI.setVisible({
            visible: false
        });
    }
    return {
        openQRCodePopup,
        closeQRCodePopup
    };
}
